import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import styles from './VoucherCancellationConfirmationStep.module.css'

export function VoucherCancellationConfirmationStep() {
  const { formatMessage } = useIntl()

  return (
    <Typography variant="body-m-regular-snug" as="p" className={styles.text}>
      {formatMessage({ id: 'booking_details_cancel_booking_voucher_sheet_text' })}
    </Typography>
  )
}
